import config from './config';
import {
  ADDRESS_SUGGESTIONS_ENABLED,
  ADDRESS_VERIFICATION_ENABLED
} from './env/public';
import { ADDRESS_SEARCH_BIAS_ENABLED } from './env/server';

/** Setting for address validation.  */
const address = config({
  /** Defaults for all sites and locales. */
  default: {
    /** Default settings for all languages. */
    default: {
      /**
       * Whether the address validation is biased towards the integration source criteria available.
       *
       * We are disabling this in production for now, since we have a specific ticket to refine it.
       *
       * @todo - {@link https://deckersglobal.atlassian.net/browse/DECA-5610 | DECA-5610}. Will be enabled in production after the ticket is done.
       */
      biased: { default: ADDRESS_SEARCH_BIAS_ENABLED === 'true' },

      suggestions: {
        /** Whether the address suggestions are enabled. */
        enabled: ADDRESS_SUGGESTIONS_ENABLED
      },

      verification: {
        /** Whether the address verification is enabled. */
        enabled: ADDRESS_VERIFICATION_ENABLED
      }
    }
  }
});

export default address;
